module.exports = new __parcel__URL__("VerseLogo.e24b56c2.png").toString();